
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Ev amûr dihêle hûn lîsteya pêkhateyan rast bikin. Hûn dikarin lîsteya pêkhateyan li
                zêde bikin, jê bibin an biguherînin.
                <br>
                Ev karakter <span class="highlight">␣</span> valahiyek temsîl dike.
                <br>
                Ev karakter <span class="highlight">↩︎</span> şikandina rêzekê temsîl dike. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Taybetmendî tên barkirin...`,
's000d98595e959c1e': `دایبەزێنە لە گۆگڵ پلەی`,
's013bdc8cf0d3583d': `Ji bo pêkhateyan alîkariya me bikin`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Çandiniyê piştrast bike`,
's03e9c8114521b998': `Ez ê pêkhateyan biguherînim`,
's05ec315d9308091a': `Îkona quncikên barkodê`,
's061eb5af92512c85': `Rizgar bû! Ma hûn dikarin bi yekî din re bibin alîkar?`,
's06847c221c4c0bc1': `Ez dixwazim taybetmendiyek çêbikim ji bo [rewşa karanîna xwe rave bike]...`,
's06f6c6f99db6b552': `Eslî`,
's081e2ad82db71e1d': `Nirxên Komkirî`,
's09205907b5b56cda': `No no`,
's0b4235aae602a950': `belgekirina taybet`,
's0bb2d48532acc455': `Daxistina CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Wêneyê nederbasdar bike`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Betalkirina çandinê`,
's11a18a69b30b65ed': `Ji me re bibin alîkar ku em xeletiyên di navnîşa pêkhateyan de rast bikin`,
's1205d5f6fccf8e69': `Nirxa Milkê`,
's15d64a0a6715285a': `Kilîta nû`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Qada hilbijartinê`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Ji bo rastkirina agahiyên xurekî alîkariya me bikin`,
's1e00019dc454872d': `Ji kerema xwe navekî taybetmendiyê bi karanîna taybetmendiya property-name peyda bikin.`,
's1e49126af0935a5b': `Lîsteya berhemên ku vê taybetmendiyê bikar tînin`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Milkê belge bike`,
's300b3a6ee4e1252d': str`Lihevhatina Xirab ${0}%`,
's33f786bb6b4f0cf4': `Encama Çandinê`,
's33f85f24c0f5f008': `Rekor`,
's34be4af4e8fec4ae': `Pêşî ji civakê bipirse`,
's36d86adc823cbfa6': `Berî afirandina milkê nû, li ser vê yekê bi civakê re nîqaş bikin:`,
's3781d25aa51a736c': `Belgekirina Motora Folksonomy`,
's383ae4449428b61e': `Çandiniyê ji nû ve vesaz bike`,
's39bcf88721a1e8ee': `Hilbijartinê ji nû ve vesaz bike`,
's39e14e14300694c7': `Belgekirin û Rêbername`,
's3b430cfa5c1fe7f4': str`Belgekirin ji bo ${0}`,
's3f4e4b52f230a892': `Kanavasa wêneyê`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Wêneya navendî`,
's42dd66b2441566fd': `Îkona navendê`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Mezinahiya rastê biguherîne`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Hejmara Berheman`,
's4df2f533c0c1e7d0': `Kontrolên wêneyan`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Hilbijartinê biguhezîne`,
's4f751fb9b3ed766c': `Çêkirina Taybetmendiyek Nû`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Navê milkê binivîse...`,
's55d7249883a98ca1': `derbarê vê milkê de li ser wîkiya Rastiyên Xwarinê yên Vekirî`,
's565867d84c04aea2': `Taybetmendiyên fîlterê...`,
's5666afe5cd0166de': `Ji kerema xwe berî piştrastkirinê xeletiyan rast bikin an jî nivîsê biguherînin`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Berhem tên barkirin...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Ji bo rastkirina agahiyên xurekî alîkariya me bikin.`,
's5dd6f12783fca34f': `Lîsteya pêkhateyan biguherîne`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Wêneya Birrkirî`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Lihevhatina Baş ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Belgekirin`,
's787dd11bed0dc88a': `Mezinahiya çepê biguherîne`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Zêdetir li ser afirandina milk û rêbernameyan fêr bibin:`,
's8038273de2cf8b73': `Ji kerema xwe herêmekê hilbijêre ji bo birrînê.`,
's839cc2908a5387f2': `Barkodên parzûnkirinê...`,
's86197dcf3e96af64': `Li milkên heyî bigerin û lê bigerin`,
's8a63be30a129a59c': `Mezinahiya jêrîn biguherîne`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Mezinahiya jorê rastê biguherîne`,
's8db84aa4bc949af2': `Milkê Nû Belge Bike`,
's8f839a03997a16d7': `Berhemê Bibîne`,
's901ae1e236ac45d3': `Jêbirinê betal bike`,
's907f7a97c6b29425': `Hay ji xwe hebe ku modela daneyan dibe ku were guhertin. Bi berpirsiyariya xwe bikar bînin.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Pêkhate:`,
's9a7f60fce090ecaf': `Taybetmendî nehat barkirin. Ji kerema xwe paşê dîsa biceribînin.`,
's9b87abd68fb9df45': `Nehat dîtin? Kilîtek nû biafirîne {value}`,
's9c0f52425fd2f07e': `Dibe ku Lihev Neke`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Pûan tune ye`,
'sa548778b24054030': `Hemû taybetmendiyên ku ji projeya Folksonomy Engine hatine beşdarkirin bikolin. Ev taybetmendî metadata û têgihîştinên zêdetir li ser hilberên di databasa Open Food Facts de peyda dikin.`,
'sa63907958bd0ec4b': `Mezinahiya jorîn çepê biguherîne`,
'sa95b4224f685a36a': `Modal bigire`,
'sab56a1d439576fd6': `Îkona pêşniyarê`,
'sac47ea2901d04c15': `Mezinahiya jêrîn a çepê biguherîne`,
'sb125227d436c2925': `Li têgeha milkê xwe di databasa milkên heyî de bigere:`,
'sb125568d43642e6f': `Bersiva pirsên di derbarê hilberê de bidin.`,
'sb1c538e038f9b214': str`Lihevhatina Gelek Baş ${0}%`,
'sb28639570ff3b852': `lîsteya hemû milkên`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Gava ku te piştrast kir ku milkê te tune ye û civak qebûl dike ku ew kêrhatî ye, divê tu pêşî wê di wîkiyê de belge bikî.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Ji bo vê milkê ti berhem nehatin dîtin.`,
'sb7f72e4c8a2d3357': `Nirxên fîltrekirinê...`,
'sb8178320160f84ea': `Berhemê nîşan bide`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Bersiva hemû têbînîyan hatiye dayîn! Spas ji bo alîkariya te!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Nirxa Berawirdî`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Mezinahiya jorîn biguherîne`,
'sc1c08d0cbcc3bd24': `Lihev nayê`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Çareserkirina pêşniyarkirî`,
'sc681b137e8f604f7': `Jêbirinê piştrast bike`,
'sc6daf8a31883f8b9': `Wêneyê biguhezîne`,
'sc895972c88d38ca5': `Taybetmendiya Folksonomiyê`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Rêz`,
'scb3b0671d7b7f640': `Nirxa nû`,
'scb489a1a173ac3f0': `Erê`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Tevlî nîqaşa Slack bibe`,
'scdb6cad0b92721bf': `Ti taybetmendî nehat dîtin.`,
'scf23a05631f93732': `Jêbirinê piştrast bike`,
'scfed2f270ef6a3aa': `Herêmê hilbijêre`,
'sd1022bc1ef9204f7': `Wêneya mezinkirî`,
'sd1077c055cf9ba6b': `Ji bo piştrastkirina navnîşa pêkhateyên hilberê, alîkariya me bikin.`,
'sd698d21ddecba56b': `Silav! Tu dikarî bi bersivandina beşên jêrîn alîkariya me bikî ku em agahdariya hilberê baştir bikin:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Kontrol bike ka taybetmendiyek jixwe heye an na`,
'sdbf806fefc584115': `Divê hûn yek bibînin`,
'sdc673e73b5c13aea': `Paqijkirin`,
'sdc792b75f1edcaba': `Ji bo rastkirina rastnivîsa pêkhateyan alîkariya me bikin.`,
'sdca5deead576ceee': `Mezinahiya jêrîn a rastê biguherîne`,
'sdcc2555c5dde524f': `Ma tu piştrast î ku dixwazî vê tiştê jê bibî? Ev çalakî nayê vegerandin.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Nederbasdar bike`,
'se5127cf0f92e7e48': `Şîret: hûn dikarin di heman demê de bibînin`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ez ê çandiniyek çêtir pêşniyar bikim`,
'seea3800e27baa686': `Berhemên Takekesî`,
'sefaba4adc4ec9219': `Taybetmendiyên Folksonomiyê`,
'seffa8ca49175b5f0': `Taybetmendiyên kesanekirî`,
'sf44a6b3b232c28ea': str`Nirxa niha bi ${0}biguherînin`,
'sf4cd86a2f5ef2588': `Barkoda Berhemê`,
'sf57a61152168cc81': `Alîkariya me bikin ku em tespîtkirina pêkhateyan rast bikin`,
'sf88b90b8ba23871c': `Maça Nenas`,
'sf9aee319a006c9b4': `Lê zêde bike`,
'sfacbbe968fa7d773': `Navê milkê:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Nirxa têkildar`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  